import { sizeList } from '@/views/inHouse/newProductCheck/sizeList.js'
import { getCategoryConfigListApi } from '@/apis/inHouse'
export default {
  data() {
    return {
      sizes: [],
      options: [],
      sizeList: []
    }
  },
  methods: {
    getSizeList() {
      const list = this.sizes
      if(this.category === 'all') {
        this.sizeList = list.filter((v) => !v.isSpecial).map(v => {
          return {
            ...v,
            value: this.productMeasureDtoList?.filter(y => y.code == v.code)?.length ? this.productMeasureDtoList?.filter(y => y.code == v.code)[0].value : ''
          }
        })
      }else {
        const codes = this.options.find((v) => v.value === this.category)?.values?.split(',')
        this.sizeList = codes.map(codeItem => {
          return {
            ...(list.find(v => v.code === codeItem) ?? {}),
            value: this.productMeasureDtoList?.filter(y => y.code == codeItem)?.length ? this.productMeasureDtoList?.filter(y => y.code == codeItem)[0].value : ''
          }
        })
      }
    },
    openImage() {
      this.prewImage = this.options.find((v) => v.value === this.category)?.referenceImage
      this.dialogVisible = true
    },
    changeSelect(e) {
      this.getSizeList()
    }
  },
  mounted() {
    this.sizes = sizeList.map((v) => {
      return {
        ...v,
        value: ''
      }
    })
    this.getSizeList()
    getCategoryConfigListApi().then((res) => {
      console.log('ee', res)
      this.options = res.data?.map((v) => ({
        ...v,
        label: v.name,
        value: v.key,
        values: v.value
      }))
    })
  }
}
